import { httpClient } from 'app/api/http/http-client';
import { TransactionsRequestType } from 'app/utils/services/types/transactions.type';
import { useMutation, useQuery } from 'react-query';

const refreshToken = localStorage.getItem('refreshToken');

const templateService = {
  createTemplate: async (data: any): Promise<any> => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/save_template', data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'templates-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
  getTemplates: async (): Promise<any> => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/get_templates', { limit: '30', offset: '0' });

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'templates-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
  deleteTemplate: async (data: any) => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/edit_template', data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'templates-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  changeNameTemplate: async (data: any) => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/edit_template', data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'templates-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  filterTemplate: async (data: any) => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/get_templates', data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'templates-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  editTemplate: async (data: any) => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/edit_template', data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'templates-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
};

export const useCreateTemplateService = () => {
  const {
    isLoading: isLoadingCreateTemplate,
    mutate: createTemplateMutation,
    data: dataCreateTemplate,
  } = useMutation('createTemplate', (data: any) => templateService.createTemplate(data));

  return {
    isLoadingCreateTemplate,
    createTemplateMutation,
    dataCreateTemplate,
  };
};

export const useGetTemplates = () => {
  const {
    isLoading: isLoadingGetTemplates,
    data: dataGetTemplates,
    refetch: refetchGetTemplate,
  } = useQuery('getTemplate', templateService.getTemplates, { enabled: false });

  return { isLoadingGetTemplates, refetchGetTemplate, dataGetTemplates };
};

export const useDeleteTemplate = (isEdit: boolean) => {
  const { isLoadingGetTemplates, refetchGetTemplate, dataGetTemplates } = useGetTemplates();

  const {
    isLoading: isLoadingDeleteTemplate,
    mutate: deleteTemplateMutation,
    data: dataDeleteTemplate,
  } = useMutation('deleteTemplate', (data: any) => templateService.deleteTemplate(data), {
    onSuccess: () => {
      if (!isEdit) {
        refetchGetTemplate();
      }
    },
  });

  return {
    isLoadingDeleteTemplate,
    deleteTemplateMutation,
    dataDeleteTemplate,
  };
};

export const useChangeNameTemplate = () => {
  const { isLoadingGetTemplates, refetchGetTemplate, dataGetTemplates } = useGetTemplates();

  const {
    isLoading: isLoadingChangeNameTemplate,
    mutate: changeNameTemplateMutation,
    data: dataChangeNameTemplate,
  } = useMutation('changeNameTemplate', (data: any) => templateService.changeNameTemplate(data), {
    onSuccess: () => {
      refetchGetTemplate();
    },
  });

  return {
    isLoadingChangeNameTemplate,
    changeNameTemplateMutation,
    dataChangeNameTemplate,
  };
};

export const useFilterTemplate = () => {
  const {
    isLoading: isLoadingFilterTemplate,
    mutate: filterTemplateMutation,
    data: dataFilterTemplate,
  } = useMutation('filterTemplate', (data: any) => templateService.filterTemplate(data));

  return {
    isLoadingFilterTemplate,
    dataFilterTemplate,
    filterTemplateMutation,
  };
};

export const useEditTemplate = () => {
  const {
    isLoading: isLoadingEditTemplate,
    mutate: editTemplateMutation,
    data: dataEditTemplate,
  } = useMutation('createTemplate', (data: any) => templateService.editTemplate(data));

  return {
    isLoadingEditTemplate,
    editTemplateMutation,
    dataEditTemplate,
  };
};
